export default __webpack_public_path__ + "static/media/sumoling.eb1b972d.svg";